<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Events</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Events</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100  verticaltab--1">
  <div class="container">
    <div class="row row-cols-1 justify-content-center">
      <div class="nav flex-column nav-pills vertival-sticky col-lg-3 col" id="v-pills-tab" role="tablist"
        aria-orientation="vertical">

        <button class="nav-link active" id="v-pills-criteria1-tab" data-bs-toggle="pill"
          data-bs-target="#v-pills-criteria10" type="button" role="tab" aria-controls="v-pills-criteria10"
          aria-selected="true"> APAV workshop</button>
        <button class="nav-link " id="v-pills-criteria1-tab" data-bs-toggle="pill" data-bs-target="#v-pills-criteria11"
          type="button" role="tab" aria-controls="v-pills-criteria11" aria-selected="true">Voter Education</button>
        <button class="nav-link " id="v-pills-criteria1-tab" data-bs-toggle="pill" data-bs-target="#v-pills-criteria17"
          type="button" role="tab" aria-controls="v-pills-criteria17" aria-selected="true">Inter Zonal Netball
          Tournament</button>
      </div>
      <div class="tab-content col-lg-9 col" id="v-pills-tabContent">
        <!-- criteria 1 -->
        <div class="tab-pane fade show active" id="v-pills-criteria10" role="tabpanel"
          aria-labelledby="v-pills-criteria10-tab">
          <h3 class="yellow-color"> APAV workshop</h3>
          <div class="gallery-sec mt-3">
            <div class="demo-gallery pt-40 mt-4">
              <ul  appLightgallery>
                <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva1.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva1.webp"
                       alt="APAV workshop | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>APAV workshop</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
                <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva2.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva2.webp"
                       alt="APAV workshop | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>APAV workshop</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
                <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva3.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva3.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva3.webp"
                       alt="APAV workshop | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>APAV workshop</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
                <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva4.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva4.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva4.webp"
                      alt="APAV workshop | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>APAV workshop</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
                <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva5.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva5.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/news/apvaworkshop/apva5.webp"
                      alt="APAV workshop | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>APAV workshop</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-criteria11" role="tabpanel" aria-labelledby="v-pills-criteria11-tab">
          <h3 class="yellow-color">Voter Education </h3>
          <div class="gallery-sec mt-3">
            <div class="demo-gallery pt-40 mt-4">
              <ul  appLightgallery>
                <li
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/matadan-jagruti.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/matadan-jagruti.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/matadan-jagruti.webp"
                      alt="Voter Education | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>Voter Education and Electrol Participation Programme (SVEEP)</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="v-pills-criteria17" role="tabpanel" aria-labelledby="v-pills-criteria17-tab">
          <h3 class="yellow-color">Inter Zonal Netball Tournament </h3>
          <div class="gallery-sec mt-3">
            <div class="demo-gallery pt-40 mt-4">
              <ul  appLightgallery>
                <li
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/zonal-net-tour-1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/zonal-net-tour-1.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/zonal-net-tour-1.webp"
                      alt="Inter Zonal Netball Tournament | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>Inter Zonal Netball Tournament</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
                <li
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/zonal-net-tour-2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/zonal-net-tour-2.webp">
                  <a href="#">
                    <img class="img-responsive"
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/latest-news/zonal-net-tour-2.webp"
                      alt="Inter Zonal Netball Tournament | GHRCACS, PUNE">
                    <div class="demo-gallery-poster">
                      <h6>Inter Zonal Netball Tournament</h6>
                      <div class="line"></div>
                      <i class="fa fa-search-plus"></i>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

